import { Link } from "react-router-dom";
import { services } from "@/data/services";
import { ArrowRight } from "lucide-react";
// framer-motion verwijderd — entree-animatie via `animate-fade-in` met inline delay.

const ServicesOverview = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold md:text-4xl">
            Alles wat je nodig hebt,{" "}
            <span className="text-gradient">onder één dak</span>
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Van internet tot werkplekken — wij regelen het. Simpel, betrouwbaar en voor een vast bedrag.
          </p>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={service.slug}
                className="animate-fade-in [animation-fill-mode:backwards]"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <Link
                  to={service.slug === "alles-in-een" ? "/contact" : `/diensten/${service.slug}`}
                  className={`group flex h-full flex-col rounded-xl border p-6 shadow-card transition-all duration-300 hover:shadow-card-hover hover:-translate-y-1 ${
                    service.slug === "alles-in-een"
                      ? "border-primary/30 bg-hero-gradient text-primary-foreground"
                      : "border-border bg-card"
                  }`}
                >
                  <div className={`mb-4 flex h-11 w-11 items-center justify-center rounded-xl ${
                    service.slug === "alles-in-een"
                      ? "bg-white/20"
                      : index % 3 === 0 ? "bg-hero-gradient" : index % 3 === 1 ? "bg-rinqel-blue-gradient" : "bg-rinqel-green-gradient"
                  }`}>
                    <Icon className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <h3 className="text-lg font-semibold">{service.title}</h3>
                  <p className={`mt-2 flex-1 text-sm leading-relaxed ${
                    service.slug === "alles-in-een" ? "text-primary-foreground/80" : "text-muted-foreground"
                  }`}>
                    {service.description}
                  </p>
                  <div className={`mt-4 flex items-center gap-1 text-sm font-semibold ${
                    service.slug === "alles-in-een" ? "text-primary-foreground" : "text-primary"
                  }`}>
                    {service.slug === "alles-in-een" ? "Neem contact op" : "Bekijk dienst"}
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
